import moment from "moment";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { RubriqueDto } from "../../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import { SalarieContratDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieContratDto";
import { ScenariosDto } from "../../../dto/GenApi.iNotPaie.Dto/ScenariosDto";
import { EventBus } from "../../Controls/EventBus";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { ParametresInstance } from "../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

interface RubriquesVisibleContrat {
    id: number;
    code: string;
    libelle: string;
    valeur?: number;
    modifiable: boolean;
}

@Component
export default class ListeRubriquesSalarieComponent extends Vue {
    public currentId = 0;
    public dataReady = false;
    public isModDemarrage = false;
    @Prop()
    public salarieCourant?: SalarieContratDto;

    @Watch("salarieCourant")
    public onsalarieCourantChanged(): void {
        this.initConstantes();
    }

    public canModify = false;

    //* * Les listes des rubriques et scenarios **//
    public listeRubriques: RubriqueDto[] = [];
    public listeScenarios: ScenariosDto[] = [];
    public listeRubriquesVisibleContrat: RubriquesVisibleContrat[] = [];

    //* * Les listes des parametres **//
    public listeConventionCollectives: ParametreDto[] = ParametresInstance.listeConventionCollectives;
    public listeClassifications: ParametreDto[] = ParametresInstance.listeClassifications;
    public listeQualifications: ParametreDto[] = ParametresInstance.listeQualifications;
    public listeCodeInsees: ParametreDto[] = ParametresInstance.listeCodeInsees;
    public listeDureeContrats: ParametreDto[] = ParametresInstance.listeDureeContrats;
    public listeNatureContrats: ParametreDto[] = ParametresInstance.listeNatureContrats;
    public listeTypeContrats: ParametreDto[] = ParametresInstance.listeTypeContrats;
    public listeRemunerations: ParametreDto[] = ParametresInstance.listeRemunerations;
    public listeMaladieRetraites: ParametreDto[] = ParametresInstance.listeMaladieRetraites;

    public listeTransports: ParametreDto[] = ParametresInstance.listeTransports;
    public listeGestionConges: ParametreDto[] = ParametresInstance.listeGestionConges;
    public listeCaisseComplementaires: ParametreDto[] = ParametresInstance.listeCaisseComplementaires;
    public listePrevoyances: ParametreDto[] = ParametresInstance.listePrevoyances;
    public listeMutuelles: ParametreDto[] = ParametresInstance.listeMutuelles;
    public listePoints: ParametreDto[] = ParametresInstance.listePoints;

    public mounted(): void {
        EventBus.$on(EventConstants.UTILISATEUR_CHANGED, () => {
            if (ParametresInstance.utilisateurCourant == undefined) {
                return;
            }
            this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) && this.salarieCourant != undefined && this.salarieCourant.IsCurrent;
        });
        if (ParametresInstance.utilisateurCourant == undefined) {
            return;
        }
        this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) && this.salarieCourant != undefined && this.salarieCourant.IsCurrent;

        this.initConstantes();
        EventBus.$on(EventConstants.ALL_LISTES_LOADED, () => {
            this.listeConventionCollectives = ParametresInstance.listeConventionCollectives;
            this.listeClassifications = ParametresInstance.listeClassifications;
            this.listeQualifications = ParametresInstance.listeQualifications;
            this.listeCodeInsees = ParametresInstance.listeCodeInsees;
            this.listeDureeContrats = ParametresInstance.listeDureeContrats;
            this.listeNatureContrats = ParametresInstance.listeNatureContrats;
            this.listeTypeContrats = ParametresInstance.listeTypeContrats;
            this.listeRemunerations = ParametresInstance.listeRemunerations;
            this.listeMaladieRetraites = ParametresInstance.listeMaladieRetraites;

            this.listeTransports = ParametresInstance.listeTransports;
            this.listeGestionConges = ParametresInstance.listeGestionConges;
            this.listeCaisseComplementaires = ParametresInstance.listeCaisseComplementaires;
            this.listePrevoyances = ParametresInstance.listePrevoyances;
            this.listeMutuelles = ParametresInstance.listeMutuelles;
            this.refreshRubriquesVisibleContrat();
        });

        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);
        });
        this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);
    }

	public initConstantes(): void {
		ServicesFactoryInstance.RubriquesService.getRubriquesNonArchivee("S", (data) => {
			this.listeRubriques = data;
			this.listeRubriques.sort((a, b) => (a.NumeroSequence == undefined ? 0 : a.NumeroSequence) - (b.NumeroSequence == undefined ? 0 : b.NumeroSequence));
			this.refreshRubriquesVisibleContrat();
		});

        ServicesFactoryInstance.ScenariosService.getScenariosByNat("S", (data) => {
            this.listeScenarios = data;
            this.refreshRubriquesVisibleContrat();
        });
    }

    public modifyDureeContrat(duree: number): void {
        const rub = this.listeRubriquesVisibleContrat.filter(r => r.code == "361")[0];
        if (rub != undefined) {
            rub.valeur = duree;
            this.$forceUpdate();
        }
    }

    public refreshRubriquesVisibleContrat(parametreActualise?: ParametreDto): void {
        this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) && this.salarieCourant != undefined && this.salarieCourant.IsCurrent;
        this.listeRubriquesVisibleContrat = [];
        if (ParametresInstance.allListesLoaded > 0) {
            return;
        }
        if (!this.salarieCourant) {
            return;
        }
        if (this.listeRubriques.length == 0) {
            return;
        }
        if (this.listeScenarios.length == 0) {
            return;
        }

        const listeCodeRubrique: string[] = ["027"];// Christian a dit : "Je veux toujours la 027 !"...

        for (let i = 0; i < this.listeScenarios.length; i++) {
            const scenario = this.listeScenarios[i];

            if (scenario.CodeTypeScenario == "CONVT" && scenario.CodeSousTypeScenario == this.salarieCourant.CodeConventionCollective) {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "CLASI" && scenario.CodeSousTypeScenario == this.salarieCourant.CodeClassification) {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "QUALI" && scenario.CodeSousTypeScenario == this.salarieCourant.CodeQualification) {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "CONTR" && scenario.CodeSousTypeScenario == this.salarieCourant.CodeTypeContrat) {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "NATCO" && scenario.CodeSousTypeScenario == this.salarieCourant.CodeNatureContrat) {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "COTIS" && scenario.CodeSousTypeScenario == this.salarieCourant.CodeMaladieRetraite) {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "REMUN" && scenario.CodeSousTypeScenario == this.salarieCourant.CodeRemuneration) {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "CONGE" && scenario.CodeSousTypeScenario == this.salarieCourant.CodeGestionConge) {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "ORGAN" && (scenario.CodeSousTypeScenario == this.salarieCourant.CodeCaisseComplementaire || scenario.CodeSousTypeScenario == this.salarieCourant.CodeAutreCaisse)) {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "TRANS" && scenario.CodeSousTypeScenario == this.salarieCourant.CodeTransport) {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "SOCTE" && scenario.CodeSousTypeScenario == "*") {
                listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
            }
            if (scenario.CodeTypeScenario == "POINT") {
                if (scenario.CodeSousTypeScenario == "01" && this.salarieCourant.SalairePerso) {
                    listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
                }
                if (scenario.CodeSousTypeScenario == "03" && this.salarieCourant.TicketsRestaurant) {
                    listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
                }
                if (scenario.CodeSousTypeScenario == "11" && this.salarieCourant.FraisProfessionnels) {
                    listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
                }
                if (scenario.CodeSousTypeScenario == "04" && this.salarieCourant.TreiziemeMois) {
                    listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
                }
                if (scenario.CodeSousTypeScenario == "12" && this.salarieCourant.ExonerationCsg) {
                    listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
                }
                if (scenario.CodeSousTypeScenario == "05" && this.salarieCourant.AvantageEnNature) {
                    listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
                }
                if (scenario.CodeSousTypeScenario == "13" && this.salarieCourant.CongesDixieme) {
                    listeCodeRubrique.push(scenario.CodeRubrique ? scenario.CodeRubrique : "");
                }
            }
        }

        for (let i = 0; i < this.listeRubriques.length; i++) {
            const rub = this.listeRubriques[i];
            if (listeCodeRubrique.filter(r => r == rub.CodeRubrique).length > 0) {
                let valeur = rub.DefaultValue;

                let valeurContrat = this.salarieCourant.RubriqueContrats.filter(r => r.CodeRubrique == rub.CodeRubrique);
                if (parametreActualise != undefined &&
                    valeurContrat != undefined &&
                    valeurContrat[0] != undefined &&
                    (parametreActualise.CodeRubrique1 == valeurContrat[0].CodeRubrique ||
                        parametreActualise.CodeRubrique2 == valeurContrat[0].CodeRubrique ||
                        parametreActualise.CodeRubrique3 == valeurContrat[0].CodeRubrique)) {
                    // Le paramètre actualisé correspond au paramètre qui a déclenché le rafraichissement de la liste.
                    // Lorsqu'il est passé en paramètre, c'est pour forcer l'actualisation des valeurs qui en découlent même si la rubrique est modifiable.
                    // Pour celà, on ignore les valeurs concernées dans le contrat pour les réinjecter depuis la rubrique concernée.
                    valeurContrat = [];
                }

                if (this.isModDemarrage && rub.CodeRubrique == "022") {
                    rub.Modifiable = true;
                }

                if ((rub.Modifiable || rub.CodeRubrique == "022" || rub.CodeRubrique == "058") && valeurContrat.length > 0 && valeurContrat[0].Value != undefined) {
                    valeur = valeurContrat[0].Value;
                } else {
                    if (this.salarieCourant != undefined) {
                        // Convention collective (Nouveau client : Par défaut jusqu'à ce que la qualification soit renseignée pour le contrat).
                        const conv = this.listeConventionCollectives.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeConventionCollective);
                        if (conv.length == 1) {
                            if (conv[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = conv[0].Valeur1;
                            }
                            if (conv[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = conv[0].Valeur2;
                            }
                            if (conv[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = conv[0].Valeur3;
                            }
                        }

                        // Qualification
                        const qualif = this.listeQualifications.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeQualification);
                        if (qualif.length == 1) {
                            if (qualif[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = qualif[0].Valeur1;
                            }
                            if (qualif[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = qualif[0].Valeur2;
                            }
                            if (qualif[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = qualif[0].Valeur3;
                            }
                        }
                        const classif = this.listeClassifications.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeClassification);
                        if (classif.length == 1) {
                            if (classif[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = classif[0].Valeur1;
                            }
                            if (classif[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = classif[0].Valeur2;
                            }
                            if (classif[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = classif[0].Valeur3;
                            }
                        }

                        const insee = this.listeCodeInsees.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeCodeInsee);
                        if (insee.length == 1) {
                            if (insee[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = insee[0].Valeur1;
                            }
                            if (insee[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = insee[0].Valeur2;
                            }
                            if (insee[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = insee[0].Valeur3;
                            }
                        }
                        const duree = this.listeDureeContrats.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeDureeContrat);
                        if (duree.length == 1) {
                            if (duree[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = duree[0].Valeur1;
                            }
                            if (duree[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = duree[0].Valeur2;
                            }
                            if (duree[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = duree[0].Valeur3;
                            }
                        }

                        // Contrat
                        const nature = this.listeNatureContrats.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeNatureContrat);
                        if (nature.length == 1) {
                            if (nature[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = nature[0].Valeur1;
                            }
                            if (nature[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = nature[0].Valeur2;
                            }
                            if (nature[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = nature[0].Valeur3;
                            }
                        }
                        const type = this.listeTypeContrats.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeTypeContrat);
                        if (type.length == 1) {
                            if (type[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = type[0].Valeur1;
                            }
                            if (type[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = type[0].Valeur2;
                            }
                            if (type[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = type[0].Valeur3;
                            }
                        }

                        const remun = this.listeRemunerations.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeRemuneration);
                        if (remun.length == 1) {
                            if (remun[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = remun[0].Valeur1;
                            }
                            if (remun[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = remun[0].Valeur2;
                            }
                            if (remun[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = remun[0].Valeur3;
                            }
                        }

                        const maladie = this.listeNatureContrats.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeMaladieRetraite);
                        if (maladie.length == 1) {
                            if (maladie[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = maladie[0].Valeur1;
                            }
                            if (maladie[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = maladie[0].Valeur2;
                            }
                            if (maladie[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = maladie[0].Valeur3;
                            }
                        }

                        const mutuel = this.listeMutuelles.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeMutuelle);
                        if (mutuel.length == 1) {
                            if (mutuel[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = mutuel[0].Valeur1;
                            }
                            if (mutuel[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = mutuel[0].Valeur2;
                            }
                            if (mutuel[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = mutuel[0].Valeur3;
                            }
                        }

                        const prevoy = this.listePrevoyances.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodePrevoyance);
                        if (prevoy.length == 1) {
                            if (prevoy[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = prevoy[0].Valeur1;
                            }
                            if (prevoy[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = prevoy[0].Valeur2;
                            }
                            if (prevoy[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = prevoy[0].Valeur3;
                            }
                        }

                        const trans = this.listeTransports.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeTransport);
                        if (trans.length == 1) {
                            if (trans[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = trans[0].Valeur1;
                            }
                            if (trans[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = trans[0].Valeur2;
                            }
                            if (trans[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = trans[0].Valeur3;
                            }
                        }

                        const caisseCompl = this.listeCaisseComplementaires.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeCaisseComplementaire);
                        if (caisseCompl.length == 1) {
                            if (caisseCompl[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = caisseCompl[0].Valeur1;
                            }
                            if (caisseCompl[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = caisseCompl[0].Valeur2;
                            }
                            if (caisseCompl[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = caisseCompl[0].Valeur3;
                            }
                        }

                        const autreCaiss = this.listeCaisseComplementaires.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeAutreCaisse);
                        if (autreCaiss.length == 1) {
                            if (autreCaiss[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = autreCaiss[0].Valeur1;
                            }
                            if (autreCaiss[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = autreCaiss[0].Valeur2;
                            }
                            if (autreCaiss[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = autreCaiss[0].Valeur3;
                            }
                        }

                        const conges = this.listeGestionConges.filter(q => this.salarieCourant != undefined && q.Code == this.salarieCourant.CodeGestionConge);
                        if (conges.length == 1) {
                            if (conges[0].CodeRubrique1 == rub.CodeRubrique) {
                                valeur = conges[0].Valeur1;
                            }
                            if (conges[0].CodeRubrique2 == rub.CodeRubrique) {
                                valeur = conges[0].Valeur2;
                            }
                            if (conges[0].CodeRubrique3 == rub.CodeRubrique) {
                                valeur = conges[0].Valeur3;
                            }
                        }

                        // Points - Notaire Salarié
                        if (this.salarieCourant.EstNotaireSalarie) {
                            const pointNotaireSalarie = this.listePoints.filter(p => p.Code == "06");
                            if (pointNotaireSalarie.length == 1) {
                                if (pointNotaireSalarie[0].CodeRubrique1 == rub.CodeRubrique) {
                                    valeur = pointNotaireSalarie[0].Valeur1;
                                }
                                if (pointNotaireSalarie[0].CodeRubrique2 == rub.CodeRubrique) {
                                    valeur = pointNotaireSalarie[0].Valeur2;
                                }
                                if (pointNotaireSalarie[0].CodeRubrique3 == rub.CodeRubrique) {
                                    valeur = pointNotaireSalarie[0].Valeur3;
                                }
                            }
                        }

                        // Points - Tickets restaurant
                        if (this.salarieCourant.TicketsRestaurant) {
                            const ticketsRestauParam = this.listePoints.filter(p => p.Code == "03");
                            if (ticketsRestauParam.length == 1) {
                                if (ticketsRestauParam[0].CodeRubrique1 == rub.CodeRubrique) {
                                    valeur = ticketsRestauParam[0].Valeur1;
                                }
                                if (ticketsRestauParam[0].CodeRubrique2 == rub.CodeRubrique) {
                                    valeur = ticketsRestauParam[0].Valeur2;
                                }
                                if (ticketsRestauParam[0].CodeRubrique3 == rub.CodeRubrique) {
                                    valeur = ticketsRestauParam[0].Valeur3;
                                }
                            }
                        }
                        // Points - Frais professionnels
                        if (this.salarieCourant.FraisProfessionnels) {
                            const FraisProfressionnelsParam = this.listePoints.filter(p => p.Code == "11");
                            if (FraisProfressionnelsParam.length == 1) {
                                if (FraisProfressionnelsParam[0].CodeRubrique1 == rub.CodeRubrique) {
                                    valeur = FraisProfressionnelsParam[0].Valeur1;
                                }
                                if (FraisProfressionnelsParam[0].CodeRubrique2 == rub.CodeRubrique) {
                                    valeur = FraisProfressionnelsParam[0].Valeur2;
                                }
                                if (FraisProfressionnelsParam[0].CodeRubrique3 == rub.CodeRubrique) {
                                    valeur = FraisProfressionnelsParam[0].Valeur3;
                                }
                            }
                        }
                        // Points - Treizième mois
                        if (this.salarieCourant.TreiziemeMois) {
                            const treiziemeMoisParam = this.listePoints.filter(p => p.Code == "04");
                            if (treiziemeMoisParam.length == 1) {
                                if (treiziemeMoisParam[0].CodeRubrique1 == rub.CodeRubrique) {
                                    valeur = treiziemeMoisParam[0].Valeur1;
                                }
                                if (treiziemeMoisParam[0].CodeRubrique2 == rub.CodeRubrique) {
                                    valeur = treiziemeMoisParam[0].Valeur2;
                                }
                                if (treiziemeMoisParam[0].CodeRubrique3 == rub.CodeRubrique) {
                                    valeur = treiziemeMoisParam[0].Valeur3;
                                }
                            }
                        }
                        // Points - Exonération CSG
                        if (this.salarieCourant.ExonerationCsg) {
                            const exonerationCsgParam = this.listePoints.filter(p => p.Code == "12");
                            if (exonerationCsgParam.length == 1) {
                                if (exonerationCsgParam[0].CodeRubrique1 == rub.CodeRubrique) {
                                    valeur = exonerationCsgParam[0].Valeur1;
                                }
                                if (exonerationCsgParam[0].CodeRubrique2 == rub.CodeRubrique) {
                                    valeur = exonerationCsgParam[0].Valeur2;
                                }
                                if (exonerationCsgParam[0].CodeRubrique3 == rub.CodeRubrique) {
                                    valeur = exonerationCsgParam[0].Valeur3;
                                }
                            }
                        }
                        // Points - Avantage en nature
                        if (this.salarieCourant.AvantageEnNature) {
                            const avantageNatureParam = this.listePoints.filter(p => p.Code == "05");
                            if (avantageNatureParam.length == 1) {
                                if (avantageNatureParam[0].CodeRubrique1 == rub.CodeRubrique) {
                                    valeur = avantageNatureParam[0].Valeur1;
                                }
                                if (avantageNatureParam[0].CodeRubrique2 == rub.CodeRubrique) {
                                    valeur = avantageNatureParam[0].Valeur2;
                                }
                                if (avantageNatureParam[0].CodeRubrique3 == rub.CodeRubrique) {
                                    valeur = avantageNatureParam[0].Valeur3;
                                }
                            }
                        }
                        // Points - Congés dixième
                        if (this.salarieCourant.CongesDixieme) {
                            const congesDixiemeParam = this.listePoints.filter(p => p.Code == "13");
                            if (congesDixiemeParam.length == 1) {
                                if (congesDixiemeParam[0].CodeRubrique1 == rub.CodeRubrique) {
                                    valeur = congesDixiemeParam[0].Valeur1;
                                }
                                if (congesDixiemeParam[0].CodeRubrique2 == rub.CodeRubrique) {
                                    valeur = congesDixiemeParam[0].Valeur2;
                                }
                                if (congesDixiemeParam[0].CodeRubrique3 == rub.CodeRubrique) {
                                    valeur = congesDixiemeParam[0].Valeur3;
                                }
                            }
                        }

                        // Les rubriques qui dépendent directement d'une valeur paramétrée dans l'onglet Qualification ou Contrat du salarié.
                        if (rub.CodeNature == "S" && rub.CodeRubrique === "999") {
                            valeur = this.salarieCourant.NbForfaitJours;
                        } else if (rub.CodeNature == "S" && rub.CodeRubrique === "007R") {
                            valeur = this.salarieCourant.NbrRttAn;
                        } else if (rub.CodeNature == "S" && rub.CodeRubrique == "900") {
                            valeur = this.salarieCourant.CsgCrdsApprenti ? 1 : 0;
                        }
                    }
                }

                this.listeRubriquesVisibleContrat.push({
                    id: rub.Id ? rub.Id : 0,
                    code: rub.CodeRubrique ? rub.CodeRubrique : "",
                    libelle: rub.LibelleRubrique ? rub.LibelleRubrique : "",
                    valeur: valeur,
                    modifiable: rub.Modifiable
                });
            }
        }
        this.$forceUpdate();
    }

    /**
     * Permet de gérer les cases à cocher relié à la rubrique 900
     * @param dateDebut
     */
    public setInfoCsg(dateDebut: Date): void {
        if (this.salarieCourant !== undefined) {
            if (this.salarieCourant.CodeTypeContrat === "APP") {

                const dateDebutContrat = moment(dateDebut);
                const dateNouvelleRegle = moment(new Date(2025, 2, 1));

                // Se coche automatiquement lorsqu'un nouveau contrat apprenti est créé dont la date de contrat >= 01/03/2025
                if (dateDebutContrat.isBefore(dateNouvelleRegle)) {
                    this.salarieCourant.CsgCrdsApprenti = false;
                } else {
                    this.salarieCourant.ExonerationCsg = true;
                    this.salarieCourant.CsgCrdsApprenti = true;
                }
            } else {
                this.salarieCourant.CsgCrdsApprenti = false;
            }
        }
    }

    public updateSalarie(): void {
        if (this.salarieCourant == undefined) {
            return;
        }
        this.salarieCourant.RubriqueContrats = [];

        for (let i = 0; i < this.listeRubriquesVisibleContrat.length; i++) {
            const rubrique = this.listeRubriquesVisibleContrat[i];
            this.salarieCourant.RubriqueContrats.push(
                {
                    Id: rubrique.id,
                    CodeRubrique: rubrique.code,
                    Value: rubrique.valeur
                });
        }
    }

    public modify(): void {
        this.$emit("isModified", true);
    }
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/listeRubriques/listeRubriquesSalarie.ts